<template>
  <v-dialog
      v-model="showDialog"
      max-width="400px"
      persistent
      scrollable
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Tour terminieren</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-text-field
              label="Name"
              v-model="predefInternal.name"
              counter
              maxlength="50"
          ></v-text-field>
          <v-textarea
              label="Beschreibung"
              v-model="predefInternal.description"
              rows="2"
              row-height="30"
          ></v-textarea>
          <v-menu
              v-model="kostMigrMenu"
              :close-on-content-click="false"
              offset-y
          >
            <template #activator="data">
              <div v-on="data.on">
                <v-select
                    ref="kostMigr"
                    :items="bhStructurePlain"
                    label="Zuständigkeit"
                    v-model="predefInternal.selectedKostMigr"
                    readonly
                    :rules="[v => !!v || '']"
                    required
                ></v-select>
              </div>
            </template>

            <v-card style="max-height: 300px">
              <v-list>
                <v-list-group
                    v-for="(level1, j) in bhStructureLevel1"
                    :key="level1.value"
                    @click=""
                >
                  <template v-slot:activator>
                    <v-list-item-icon style="margin-right: 12px">
                      <v-btn
                          icon
                          :color="predefInternal.selectedKostMigr === level1.value ? 'deep-purple accent-4' : 'dark-grey'"
                          @click.stop.prevent="predefInternal.selectedKostMigr = level1.value; kostMigrMenu = false"
                      >
                        <v-icon v-text="predefInternal.selectedKostMigr === level1.value ? 'mdi-checkbox-marked' : 'mdi-checkbox-blank-outline'"></v-icon>
                      </v-btn>
                    </v-list-item-icon>
                    <v-list-item-title v-text="level1.text"></v-list-item-title>
                  </template>
                  <v-list-item-group
                      v-model="predefInternal.selectedKostMigr"
                      single>
                    <v-list-item
                        v-for="(level2, i) in getBhStructureLevel2(level1.value)"
                        :key="level2.value"
                        :value="level2.value"
                        @click.capture.stop="predefInternal.selectedKostMigr = level2.value; kostMigrMenu = false"
                        active-class="remove-background"
                    >
                      <template v-slot:default="{ active }">
                        <v-list-item-action>
                          <v-checkbox
                              :input-value="active"
                              color="deep-purple accent-4"
                              @click.capture.stop="predefInternal.selectedKostMigr = level2.value; kostMigrMenu = false"
                          ></v-checkbox>
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title v-text="level2.text"></v-list-item-title>
                        </v-list-item-content>
                      </template>
                    </v-list-item>
                  </v-list-item-group>
                </v-list-group>
              </v-list>
            </v-card>
          </v-menu>
          <v-menu
              ref="menuFrom"
              v-model="menuFrom"
              :close-on-content-click="false"
              :return-value.sync="predefInternal.from"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="formatedFrom"
                  label="Ausführen ab:"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="predefInternal.from"
                no-title
                scrollable
                :max="predefInternal.till"
            >
              <v-spacer></v-spacer>
              <v-btn
                  text
                  color="primary"
                  @click="menuFrom = false"
              >
                Abbrechen
              </v-btn>
              <v-btn
                  text
                  color="primary"
                  @click="$refs.menuFrom.save(predefInternal.from)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-menu
              ref="menuTill"
              v-model="menuTill"
              :close-on-content-click="false"
              :return-value.sync="predefInternal.till"
              transition="scale-transition"
              offset-y
              min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  v-model="formatedTill"
                  label="Fertigstellen bis:"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
                v-model="predefInternal.till"
                no-title
                scrollable
                :min="predefInternal.from"
            >
              <v-spacer></v-spacer>
              <v-btn
                  text
                  color="primary"
                  @click="menuTill = false"
              >
                Abbrechen
              </v-btn>
              <v-btn
                  text
                  color="primary"
                  @click="$refs.menuTill.save(predefInternal.till)"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
          <v-select
              :items="automaticSelects"
              label="Fertigstellungsart"
              v-model="predefInternal.automatic"
          ></v-select>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
            color="blue darken-1"
            text
            @click="showDialog = false; $emit('cancel')"
        >
          Abbrechen
        </v-btn>
        <v-btn
            color="blue darken-1"
            text
            @click="submit"
            :disabled="!canSubmit"
        >
          Anlegen
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>

</template>

<script>
import _orderBy from "lodash/orderBy"
export default {
  name: "PlanPredefDialog",
  props: {
    predef: {
      type: Object,
      default: () => {
        return {
          id: '',
          name: '',
          description: '',
          selectedKostMigr: null,
          from: null,
          till: null,
        }
      },
    },
    bhStructure: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      showDialog: false,
      error: false,
      predefInternal: {
        id: '',
        name: '',
        description: '',
        selectedKostMigr: null,
        from: null,
        till: null,
        automatic: true,
      },
      automaticSelects: [{text: 'Automatische Fertigstellung', value: true}, {text: 'Manuelle Fertigstellung', value: false}],
      menuFrom: false,
      menuTill: false,
      kostMigrMenu: false,
    }
  },
  computed: {
    canSubmit() {
      return this.predefInternal.till && this.predefInternal.name && this.predefInternal.selectedKostMigr;
    },
    formatedFrom() {
      if (!this.predefInternal.from) return ''
      const [year, month, day] = this.predefInternal.from.split('-')
      return `${day}.${month}.${year}`
    },
    formatedTill() {
      if (!this.predefInternal.till) return 'Bitte setzen'
      const [year, month, day] = this.predefInternal.till.split('-')
      return `${day}.${month}.${year}`
    },
    bhStructurePlain() {
      let res = [];
      this.bhStructure.forEach(bh => {
        res.push({text: bh.text, value: bh.id});
        bh.children.forEach(sub => {
          res.push({text: sub.text, value: sub.id});
        });
      });
      return res;
    },
    bhStructureLevel1() {
      let res =  _orderBy(this.bhStructure.map(bh => {
        return {text: bh.text, value: bh.id};
      }), 'text');
      return res;
    },
  },
  watch: {

  },
  methods: {
    getBhStructureLevel2(id) {
      let res = [];
      this.bhStructure.forEach(bh => {
        if (bh.id === id) {
          bh.children.forEach(sub => {
            res.push({text: sub.text, value: sub.id});
          });
        }
      });
      return _orderBy(res, 'name');
    },
    show() {
      if (this.showDialog) {
        return;
      }
      this.predefInternal = {...this.predef};
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.kostMigr.validate();
      })
    },
    submit() {
      this.$emit('submit', this.predefInternal);
      this.showDialog = false;
    },
  }
}
</script>

<style scoped>
::v-deep .blue-chips .theme--light.v-chip:not(.v-chip--active) {
  background-color: #1976D2;
  color: white;
}

::v-deep .theme--light.v-input--is-disabled input {
  color: rgba(0, 0, 0, 0.87);
}


::v-deep .v-text-field .v-label {
  top: 0px;
}

</style>

